import { ProductFilters, buildFilterUrl } from '@cannect/constants/productFilters'
import { useCallback, useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import cannabisImage from '../../../../assets/img/categoryCard/CanabisMedicinal.png'
import suplementosImage from '../../../../assets/img/categoryCard/Suplementos.png'
import medicamentoImage from '../../../../assets/img/categoryCard/Medicamento.jpg'
import higieneBelezaImage from '../../../../assets/img/categoryCard/HigieneBeleza.jpg'
import viewAllImage from '../../../../assets/img/categoryCard/all.png'
import geneticTestImage from '../../../../assets/img/teste-genetico.jpg'
import { useProductClassId } from '@cannect/services/resources/classes'
import { ICategoryCard } from './types'

const isGeneticTestEnabled = import.meta.env.VITE_APP_GENETIC_TEST_ENABLED === 'true'

export const useCategoryCards = () => {
  const history = useHistory()
  const location = useLocation()
  const shouldScrollRef = useRef(false)
  const { getClassIdByName } = useProductClassId()

  // O id destas classes e gerado pelo banco de cada ambiente, entao resolvemos
  // pelo nome em vez de fixar o numero -- ver useProductClassId.
  const allopathicId = getClassIdByName('Alopático')
  const hygieneBeautyId = getClassIdByName('Higiene e Beleza')

  const cannabisClassIds = ['Espectro Completo', 'Espectro Amplo', 'Isolado', 'Sintético']
    .map((name) => getClassIdByName(name))
    .filter((id): id is number => id !== undefined)

  const categories: ICategoryCard[] = [
    {
      id: 'alopaticos',
      title: 'Medicamento',
      prescriptionLabel: 'Pode precisar de prescrição',
      image: medicamentoImage,
      path: buildFilterUrl({ ...ProductFilters.ALLOPATHIC_ALL, class_id: allopathicId })
    },
    {
      id: 'higiene-e-beleza',
      title: 'Higiene e Beleza',
      prescriptionLabel: 'Prescrição não necessária',
      image: higieneBelezaImage,
      path: buildFilterUrl({ ...ProductFilters.HYGIENE_BEAUTY_ALL, class_id: hygieneBeautyId })
    },
    {
      id: 'cannabis-medicinal',
      title: 'Cannabis Medicinal',
      prescriptionLabel: 'Prescrição necessária',
      image: cannabisImage,
      path: buildFilterUrl({ class_id: cannabisClassIds, translated_name: '' })
    },
    {
      id: 'suplementos-e-cogumelos',
      title: 'Suplementos e Cogumelos',
      prescriptionLabel: 'Prescrição não necessária',
      image: suplementosImage,
      path: buildFilterUrl(ProductFilters.SUPPLEMENTS_ALL)
    },
    ...(isGeneticTestEnabled
      ? [
          {
            id: 'teste-genetico',
            title: 'Teste Genético',
            prescriptionLabel: 'Prescrição não necessária',
            image: geneticTestImage,
            path: buildFilterUrl(ProductFilters.GENETIC_TEST_ALL)
          }
        ]
      : []),
    {
      id: 'ver-tudo',
      title: 'Ver tudo',
      image: viewAllImage,
      isViewAll: true,
      path: '/produtos/1?limit=16'
    }
  ]

  const isSelectedCategory = useCallback(
    (category: ICategoryCard) => {
      const currentPath = location.pathname + location.search
      return currentPath === category.path
    },
    [location.pathname, location.search]
  )

  useEffect(() => {
    if (shouldScrollRef.current) {
      setTimeout(() => {
        const productSection = document.querySelector('[data-product-sections]')

        if (productSection) {
          productSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        } else {
          window.scrollBy({
            top: window.innerHeight * 0.2,
            behavior: 'smooth'
          })
        }

        shouldScrollRef.current = false
      }, 300)
    }
  }, [location.pathname, location.search])

  const handleCategoryClick = useCallback(
    (category: ICategoryCard) => {
      if (category.path) {
        shouldScrollRef.current = true
        history.push(category.path)
      }
    },
    [history]
  )

  return {
    categories,
    handleCategoryClick,
    isSelectedCategory
  }
}
